import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less', './tellent-org-verification-request.component.less'],
  templateUrl: './tellent-org-verification-request.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailTellentLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class TellentOrgVerificationRequestTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentOrgVerificationRequestTemplateData>;
}

export type TellentOrgVerificationRequestTemplateData = {
  title: string;
  p1: string;
  button_text: string;
  button_link: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const TellentOrgVerificationRequestTemplateMocks: TellentOrgVerificationRequestTemplateData[] =
  [
    {
      title: 'Company successfully verified',
      p1: 'Thank you for veryfing your company account. Enjoy full access to all features.',
      button_text: 'Go to Tellent',
      button_link: 'http://admin.tellent.com',
      footer: {
        text: 'Need help?',
        href: 'https://auth.tellent.com/?intercom_open=true',
        label: 'Contact us',
        target: '_blank',
      },
    },
  ];
